import { Autocomplete, CircularProgress, TextField, createFilterOptions } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { Material } from "../../models/materialModel";
import { getMaterialLabel, getMaterials } from "../../pages/calculator/components/formHelpers";
import { db } from "../../data/db/db";
import { useTranslation } from "react-i18next";

interface MaterialsAutocompleteProps {
    ident?: string | null,
    pos?: string | undefined,
    value: Material | null,
    onChange: (newVal: Material | null) => void
    onBlur: () => void,
    disabled: boolean,
}

const AsyncMaterialsAutocomplete: React.FC<MaterialsAutocompleteProps> = ({ value, onChange, onBlur, disabled, ident, pos }: MaterialsAutocompleteProps) => {
    const [open, setOpen] = useState<boolean>(false);
    const [materials, setMaterials] = useState<Material[]>([])
    const { t } = useTranslation();

    const loading = open && materials.length === 0;

    //reset materials if ident and pos change
    useEffect(() => {
        setMaterials([])
    }, [ident, pos])


    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined
        }

        // get matching Materials for Autocomplete
        (async () => {
            if (ident && pos) {
                const materialsFromDB = await getMaterials(ident, pos)
                if (active) {
                    /* @ts-ignore */
                    setMaterials([...new Set(materialsFromDB)]);
                }
            } else{
                const materialsFromDB = await db.materials.toArray();
                if (active) {
                    /* @ts-ignore */
                    setMaterials([...new Set(materialsFromDB)]);
                }
            }

        })();

        return () => {
            active = false;
        };
    }, [loading, ident, pos])


    const filterOptions = createFilterOptions({
        trim: true,
        stringify: (option: Material) => getMaterialLabel(option)
    });


    return (
        <Autocomplete
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            loading={loading}
            loadingText={t("Lädt...")}
            noOptionsText={t("Keine Ergebnisse")}
            groupBy={(option) => option.gruppe}
            value={value}
            onBlur={onBlur}
            options={materials}
            getOptionLabel={(option: Material) => getMaterialLabel(option)}
            onChange={(event: any, newValue: Material | null) => {
                onChange(newValue)
            }}
            filterOptions={filterOptions}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disabled={disabled}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={t("Material")}
                    variant="standard"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            }
        />
    )
}

export default AsyncMaterialsAutocomplete